'use client';

import Bugsnag from "@bugsnag/js";
import MainWrap from "@/components/MainWrap";
import PageHeader from "@/components/PageHeader";
import PageTitle from "@/components/PageTitle";

export default function Error({ error, reset }: { error: Error, reset: () => void }) {
  Bugsnag.notify(error, (event) => {
    event.severity = 'error';
    event.unhandled = true;
  });

  return (
    <>
      <PageHeader>
        <PageTitle>
          <h1>Whoops, something went wrong...</h1>
        </PageTitle>
      </PageHeader>
      <MainWrap>
        <div className="main-content">
          <div className="content-main">
            There was a problem loading the page. Please try again later.
          </div>
        </div>
      </MainWrap>
    </>
  );
}